/*
CopyRight: 2019 - ArTiBulles
Created on : 02-July-2019
Author: Arnaud Jaspard - Arnaud.jaspard@artibulles.com
Version: 1.0
Description: Creating React Icons with Frames
License : MIT
*/
import React from "react";
import createSvgIcon from './utils/createSvgIcon';
var name = "Expand";
var keywords = ["Search"];
var category = "navigation";
var meta = {
  keywords: keywords,
  name: name,
  category: category,
  "class": "Icon_".concat(name)
};
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2.000000, 2.000000)",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,40 L0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 L40,0 L40,0 L40,8 L13,8 C10.2385763,8 8,10.2385763 8,13 L8,40 L8,40 L0,40 Z",
  id: "Path-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,96 L0,64 C-5.41083001e-16,59.581722 3.581722,56 8,56 L40,56 L40,56 L40,64 L13,64 C10.2385763,64 8,66.2385763 8,69 L8,96 L8,96 L0,96 Z",
  id: "Path-2",
  transform: "translate(20.000000, 76.000000) scale(1, -1) translate(-20.000000, -76.000000) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M56,40 L56,8 C56,3.581722 59.581722,8.11624501e-16 64,0 L96,0 L96,0 L96,8 L69,8 C66.2385763,8 64,10.2385763 64,13 L64,40 L64,40 L56,40 Z",
  id: "Path-2",
  transform: "translate(76.000000, 20.000000) scale(-1, 1) translate(-76.000000, -20.000000) "
}), /*#__PURE__*/React.createElement("path", {
  d: "M56,96 L56,64 C56,59.581722 59.581722,56 64,56 L96,56 L96,56 L96,64 L69,64 C66.2385763,64 64,66.2385763 64,69 L64,96 L64,96 L56,96 Z",
  id: "Path-2",
  transform: "translate(76.000000, 76.000000) scale(-1, -1) translate(-76.000000, -76.000000) "
}))), meta);